/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const JobType = {
    File: "file",
    Workbook: "workbook",
    Sheet: "sheet",
    Space: "space",
    Document: "document",
    App: "app",
    Agent: "agent",
    Autobuild: "autobuild",
    Onboarding: "onboarding",
};
